import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Branding } from '@services/branding.service';

@Injectable({
  providedIn: 'root',
})
export class IdleService {
  private timeoutId: ReturnType<typeof setTimeout> | null = null;
  private idleTime = 15 * 60 * 1000;

  private originalTitle = document.title;

  private isInactiveSubject = new BehaviorSubject<boolean>(false);
  isInactive$ = this.isInactiveSubject.asObservable();

  constructor(private ngZone: NgZone) {}

  initListener() {
    this.resetTimer();

    const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
    events.forEach(event => {
      window.addEventListener(event, () => this.resetTimer(), true);
    });
  }

  private resetTimer() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    this.ngZone.runOutsideAngular(() => {
      this.timeoutId = setTimeout(() => {
        this.ngZone.run(() => {
          this.isInactiveSubject.next(true);

          const brandingRaw = sessionStorage.getItem('branding');
          const branding: Branding | null = brandingRaw
            ? JSON.parse(brandingRaw)
            : null;
          const baseTitle = branding?.name?.trim() || 'Tourbook';

          document.title = `${baseTitle} | 🕑 ¡Estás inactivo!`;
        });
      }, this.idleTime);
    });
  }

  public setActive() {
    this.isInactiveSubject.next(false);

    const brandingRaw = sessionStorage.getItem('branding');
    const branding: Branding | null = brandingRaw
      ? JSON.parse(brandingRaw)
      : null;
    const baseTitle = branding?.name?.trim() || 'Tourbook';

    this.originalTitle = baseTitle;
    document.title = this.originalTitle;

    this.resetTimer();
  }
}
